import { Converter } from '../types/converter';

export const massFluxDensityConverter: Converter = {
  id: 'massFluxDensity',
  name: 'Mass Flux Density Converter',
  icon: 'ArrowRight',
  categories: ['engineering', 'fluids'],
  units: [
    // Base SI unit
    { name: 'Kilogram/second/square meter', symbol: 'kg/s·m²', factor: 1 },
    
    // Gram-based units
    { name: 'Gram/second/square meter', symbol: 'g/s·m²', factor: 0.001 },
    { name: 'Gram/second/square centimeter', symbol: 'g/s·cm²', factor: 10 },
    
    // Time variations
    { name: 'Kilogram/hour/square meter', symbol: 'kg/h·m²', factor: 0.000277778 },
    { name: 'Kilogram/hour/square foot', symbol: 'kg/h·ft²', factor: 0.002989957 },
    
    // Imperial/US units
    { name: 'Pound/hour/square foot', symbol: 'lb/h·ft²', factor: 0.001356227 },
    { name: 'Pound/second/square foot', symbol: 'lb/s·ft²', factor: 4.882419 }
  ]
};
